import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Product } from 'src/app/demo/domain/product';
import { ProductService } from 'src/app/demo/service/productservice';
import { DrivingSchoolDeckingStatus, School } from '../../interfaces/User';
import { UsersService } from '../../services/users.service';
import { DriverProvider } from 'protractor/built/driverProviders';
import _ from "lodash";

@Component({
    selector: 'app-decking-management',
    templateUrl: './decking-management.component.html',
    styleUrls: ['./decking-management.component.scss'],
    providers: [MessageService, ConfirmationService]
})
export class DeckingManagementComponent implements OnInit {

    recordDialog: boolean;

    records: DrivingSchoolDeckingStatus[];

    record: any;

    selectedRecords: DrivingSchoolDeckingStatus[];

    dsRecords: School[];

    dsRecord: any;

    selectedDsRecords: School[];

    submitted: boolean;

    loading: boolean = false;

    cols: any[];

    constructor(private productService: ProductService, private messageService: MessageService,
        private userService: UsersService,
        private confirmationService: ConfirmationService, private breadcrumbService: BreadcrumbService) {
        /*   this.breadcrumbService.setItems([
              {label: 'Crud'}
          ]); */
    }

    ngOnInit() {
        this.getAllDSDeckingStatus();
        this.cols = [
            { field: 'seqNo', header: 'Seq. No.' },
            { field: 'companyName', header: 'Driving School' },
            { field: 'region', header: 'Region' },
            { field: 'province', header: 'Province' },
            { field: 'status', header: 'Status' }
        ];
        this.getAllDrivingSchools();
    }

    getAllDSDeckingStatus() {
        this.loading = true;
        this.userService.getAllDrivingSchoolDeckingStatus().then((res: any) => {
            if (res.statusCode == 200) {
                this.records = res.result;
                this.records = _.sortBy(this.records, 'seqNo'); 
                this.loading = false;
            }
        }).catch((err) => {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message,
                life: 3000
            });
        });
    }

    getAllDrivingSchools() {
        this.loading = true;
        this.userService.getAllDrivingSchools().then((res: any) => {
            this.dsRecords = res.result;
            this.loading = false;
        }).catch((err) => {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message,
                life: 3000
            });
        });
    }


    addDrivingSchools(record: School) {
        this.loading = true;
        var data: DrivingSchoolDeckingStatus = {
            id: null,
            seqNo: 0,
            dsProfileId: 0,
            dsCustomId: '',
            companyName: '',
            region: '',
            province: '',
            status: ''
        };
        var seqNo = this.records.length;
        data.companyName = record.companyName;
        data.dsProfileId = record.id;
        data.dsCustomId = record.customId;
        data.province = record.address.province;
        data.region = record.address.region;
        data.seqNo = seqNo + 1; 
        data.status = null;
        console.log(record);
        console.log(data);
        this.createDrivingSchools(data);
    }

    createDrivingSchools(record: DrivingSchoolDeckingStatus) {
        this.loading = true;
        this.userService.createDrivingSchoolDeckingStatus(record).then((res: any) => {
            this.dsRecord = res.result;
            this.getAllDSDeckingStatus();
            this.loading = false;
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Record added successfuly.',
                life: 3000
            });

        }).catch((err) => {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message,
                life: 3000
            });
        });
    }

    deleteDrivingSchools(id: any) {
        this.loading = true;
        this.userService.deleteDrivingSchoolDeckingStatus(id).then((res: any) => {
            this.dsRecord = res.result;
            this.loading = false;
            this.getAllDSDeckingStatus();
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Record deleted successfuly.',
                life: 3000
            });
        }).catch((err) => {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message,
                life: 3000
            });
        });
    }

    editDrivingSchools(id: any, record: DrivingSchoolDeckingStatus) {
        this.loading = true;
        this.userService.editDrivingSchoolDeckingStatus(id, record).then((res: any) => {
            this.dsRecord = res.result;
            this.getAllDSDeckingStatus();
            this.loading = false;
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Record edited successfuly.',
                life: 3000
            });
        }).catch((err) => {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.message,
                life: 3000
            });
        });
    }

    openNew() {
        this.record = {};
        this.submitted = false;
        this.recordDialog = true;
    }

    deleteRecord(record: DrivingSchoolDeckingStatus) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete ' + record.companyName + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteDrivingSchools(record.id);
            }
        });
    }


    hideDialog() {
        this.recordDialog = false;
        this.submitted = false;
    }

    moveUp(seqNo, record: DrivingSchoolDeckingStatus) {
        if (seqNo > 1) {
            var curRecord, prevRecord;
            curRecord = record;
            curRecord.seqNo = seqNo-1;
            prevRecord = this.records[seqNo-2];
            prevRecord.seqNo = seqNo;
            this.editDrivingSchools(curRecord.id,curRecord);
            this.editDrivingSchools(prevRecord.id,prevRecord);
        }
    }

    moveDown(seqNo, record: DrivingSchoolDeckingStatus) {
        if (seqNo < this.records.length) {
            var curRecord, nextRecord;
            curRecord = record;
            curRecord.seqNo = seqNo+1;
            nextRecord = this.records[seqNo];
            nextRecord.seqNo = seqNo;          
            this.editDrivingSchools(curRecord.id,curRecord);
            this.editDrivingSchools(nextRecord.id,nextRecord);
        }
    }
}
